<template>
  <v-app id="inspire">
    <v-alert v-if="!gps" color="orange" dense prominent type="info">
      <div>
        {{
          permisoDenegado
            ? "El navegador tiene bloqueado el permiso de ubicación para este sitio. Actívalo desde la configuración del navegador (no basta con encender el GPS del equipo) y vuelve a intentar."
            : "Para ejecutar este sistema es necesario encender la geo localización de tu dispositivo."
        }}
      </div>
      <v-btn
        class="mt-2"
        small
        outlined
        color="white"
        :loading="locationLoading"
        @click="geoLocalizacion"
        >Reintentar</v-btn
      >
    </v-alert>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-col>
              <!-- <v-img src="@/assets/logo.png" contain></v-img> -->
              <!-- <v-img src="@/assets/logo4.png" contain></v-img> -->
              <v-img src="@/assets/logovml.png" contain></v-img>
            </v-col>
            <v-card-text>
              <v-form @submit.prevent="validar">
                <v-card-actions class="contIngresar">
                  <p v-if="locationLoading && gps" class="caption grey--text">
                    Obteniendo tu ubicación...
                  </p>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!latitud" color="primary" type="submit"
                    >Ingresar al caso</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { db, auth } from "../../firebase";

export default {
  name: "LoginCliente",
  data() {
    return {
      uidcaso: "",
      identificacion: "",
      placa: "",
      caso: {},
      idCliente: "",
      idVehiculo: "",
      locationLoading: false,
      latitud: null,
      longitud: null,
      ciudad: null,
      direccion: null,
      gps: true,
      permisoDenegado: false,
    };
  },
  computed: {
    logged() {
      return this.$store.getters.logged;
    },
  },
  async created() {
    // await this.GenerarTokenPush();
    if (
      this.logged &&
      localStorage.getItem("id") &&
      localStorage.getItem("id") === this.$route.params.id
    ) {
      this.$router
        .push(`/gestionar-caso/${this.$route.params.id}`)
        .catch(() => {});
    }
    this.uidcaso = this.$route.params.id;
    this.geoLocalizacion(); // GeoLocalizacion

    auth
      .signInAnonymously()
      .then(() => {})
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
      });
  },
  async mounted() {
    try {
      const caso = await db
        .collection("casos")
        .doc(this.$route.params.id)
        .get();
      this.caso = caso.data();
    } catch (error) {
      this.handleError(error);
    }
  },
  methods: {
    async geoLocalizacion() {
      this.locationLoading = true;
      this.permisoDenegado = false;
      // Oculta el aviso mientras reintenta; si vuelve a fallar, el catch lo reactiva.
      this.$store.dispatch("actionGps", true);
      try {
        const position = await this.getCurrentPosition();
        await this.getCityAndCountry(position);
      } catch (e) {
        console.error("Error de geolocalización:", e);
        // code === 1 (PERMISSION_DENIED) es un permiso del sitio bloqueado en el
        // navegador, no el GPS del equipo: encender el GPS no lo resuelve.
        this.permisoDenegado = e?.code === 1;
        this.$store.dispatch("actionGps", false);
        this.locationLoading = false;
      }
    },
    getCurrentPosition() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error),
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
      });
    },
    async getCityAndCountry(position) {
      const {
        coords: { latitude: lat, longitude: lng },
      } = position;
      const { VUE_APP_APIKEY_GEOCODE: KEY } = process.env;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${KEY}`
      );

      const { status, results } = await response.json();

      if (status !== "OK") {
        console.error("Geocoding respondió status:", status);
        throw new Error(`No se pudo obtener la dirección (status: ${status})`);
      }
      this.latitud = lat;
      this.longitud = lng;
      this.locationLoading = false;
      this.direccion = results[0].formatted_address;
      this.ciudad = results[0].address_components.find((json) =>
        json.types.includes("locality")
      )?.long_name;
    },
    async validar() {
      try {
        if (localStorage.getItem("user")) {
          localStorage.removeItem("user");
        }
        const id = this.$route.params.id;
        if (!this.caso) {
          this.handleError({ message: "El caso no existe" });
          return;
        }
        if (!this.latitud && !this.longitud) {
          this.handleError({
            message:
              "Para ejecutar este sistema es necesario encender la geo localización de tu dispositivo.",
          });
          return;
        }
        const {
          uidconductor,
          estado,
          uidciudad,
          // eslint-disable-next-line no-unused-vars
          fecha_ingreso,
          login,
          direccion_siniestro,
        } = this.caso;
        //console.log(uidconductor, estado, id);
        if (uidconductor) {
          await db
            .collection("clientes")
            .doc(uidconductor)
            .update({
              tokenPush: localStorage.getItem("tokenPush"),
            });
        }

        if (login) {
          throw new Error(
            "No puede ingresar al caso, comuníquese con un asesor"
          );
        }
        // Agregamos la fecha de ingreso del cliente
        await db.collection("casos").doc(id).update({
          fecha_ingreso: Date.now(),
          login: true,
        });

        if (estado && estado === "Recibido") {
          // console.log(this.latitud, this.longitud);
          db.collection("casos")
            .doc(id)
            .update({
              localizacion: { _lat: this.latitud, _long: this.longitud },
              ciudad_siniestro: this.ciudad,
              ...(direccion_siniestro === ""
                ? { direccion_siniestro: this.direccion }
                : {}),
              estado: "Verificado",
            })
            .then(() => {
              db.collection("trazabilidad").add({
                descripcion: "Verificación del caso.",
                fechahora: Date.now(),
                uidcaso: id,
              });
              this.notificacionesCaso(uidciudad, id); // Envio de notificaciones
            })
            .catch((error) => {
              console.log(error);
              this.handleError({ message: "El caso no existe" });
            });
        }
        await this.redireccionar();
      } catch (error) {
        this.handleError(error);
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async redireccionar() {
      localStorage.setItem("cliente", this.caso.uidcliente);
      localStorage.setItem("id", this.$route.params.id);
      this.$store.dispatch("signClienteIn", { id: this.caso.uidcliente });
      this.$router
        .push(`/gestionar-caso/${this.$route.params.id}/chat`)
        .catch(() => {});
    },
    async notificacionesCaso(ciudad, id) {
      const usuarios = await db
        .collection("usuarios")
        .where("ciudades", "array-contains", ciudad)
        .where("cargo", "in", ["Administrador", "Abogado", "Investigador"])
        .get();

      const objUsuNotificar = usuarios.docs.map((e) => ({
        ...e.data(),
      }));

      const usu = objUsuNotificar
        .filter((e) => {
          return e.tokenPush;
        })
        .map((u) => {
          return u.tokenPush;
        });

      //console.log(usu);
      usu.length > 0 && (await this.fechNotificaciones(usu, id)); // Enviar notificaciones
    },
    async fechNotificaciones(registration_ids, id) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      if (registration_ids.length <= 0) {
        return;
      }

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const url = `${ambiente}/enviarNotificacionFcm`;

      const raw = JSON.stringify({
        tokens: [...registration_ids],
        message: {
          notification: {
            title: "NUEVO CASO",
            body: `CASO CREADO EN LA CIUDAD DE ${this.ciudad.toUpperCase()}`,
          },
          data: {
            url: `${dominio}/gestionar-caso/${id}/chat`,
          },
        },
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));

      await this.redireccionar();
    },
  },
  watch: {
    "$store.state.gps": function () {
      this.gps = this.$store.state.gps;
    },
  },
};
</script>

<style scope="scss">
.contIngresar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.theme--light.v-card {
  background-color: #f6f7ff;
}
.elevation-12 {
  border: 1px solid #00000042 !important;
}
</style>
